// ── ACSM Design Tokens ────────────────────────────────────────────────────────
// Dark near-black fintech theme
// Import this in any component: import { T, pill, btn } from '../lib/theme'

export const T = {
  // Backgrounds
  bg:        '#0d1117',   // page background
  surface:   '#161b22',   // card / sidebar
  surface2:  '#1c2333',   // elevated card, table header
  surface3:  '#21262d',   // input, hover row
  border:    '#30363d',   // subtle border
  border2:   '#444c56',   // stronger border

  // Text
  txtPrimary:   '#e6edf3',  // headings
  txtSecondary: '#8b949e',  // subtext, labels
  txtMuted:     '#484f58',  // placeholder, disabled

  // Accents
  blue:    '#1E90FF',   // primary CTA, active nav
  blueD:   '#1565c0',   // hover
  blueGlow:'rgba(30,144,255,.15)',
  amber:   '#F5A623',   // highlight, active indicator
  amberD:  '#c07d0a',

  // Score band colours (text, background)
  platinum:  { c:'#58e6a0', bg:'rgba(88,230,160,.12)',  border:'rgba(88,230,160,.25)'  },
  compliant: { c:'#3fb950', bg:'rgba(63,185,80,.12)',   border:'rgba(63,185,80,.25)'   },
  watchlist: { c:'#d29922', bg:'rgba(210,153,34,.12)',  border:'rgba(210,153,34,.25)'  },
  highRisk:  { c:'#f0883e', bg:'rgba(240,136,62,.12)',  border:'rgba(240,136,62,.25)'  },
  critical:  { c:'#f85149', bg:'rgba(248,81,73,.12)',   border:'rgba(248,81,73,.25)'   },

  // Font
  font: "'Montserrat', sans-serif",
  radius: 10,
  radiusSm: 6,
}

// Band name → colour tokens
export function bandTokens(band) {
  const map = {
    'PLATINUM':  T.platinum,
    'COMPLIANT': T.compliant,
    'WATCHLIST': T.watchlist,
    'HIGH RISK': T.highRisk,
    'CRITICAL':  T.critical,
  }
  return map[band] || { c: T.txtSecondary, bg: T.surface3, border: T.border }
}

// Reusable style fragments
export const pill = (band) => {
  const tk = bandTokens(band)
  return {
    display:'inline-block', padding:'2px 9px', borderRadius:20,
    fontSize:10, fontWeight:700, letterSpacing:'.04em',
    background: tk.bg, color: tk.c, border:`1px solid ${tk.border}`,
  }
}

export const card = {
  background: T.surface,
  borderRadius: T.radius,
  border: `1px solid ${T.border}`,
  padding: 20,
  marginBottom: 16,
}

export const cardTitle = {
  fontSize: 13, fontWeight: 700, color: T.txtPrimary,
  marginBottom: 14, letterSpacing: '.01em',
}

export const th = {
  background: T.surface2, color: T.txtSecondary,
  fontWeight: 600, padding: '9px 12px',
  textAlign: 'left', fontSize: 10,
  textTransform: 'uppercase', letterSpacing: '.06em',
  borderBottom: `1px solid ${T.border}`,
}

export const td = {
  padding: '9px 12px', borderBottom: `1px solid ${T.border}`,
  verticalAlign: 'middle', color: T.txtPrimary, fontSize: 12,
}

export const tbl = {
  width:'100%', borderCollapse:'collapse', fontSize:12,
}

export const label = {
  fontSize: 11, fontWeight: 600, color: T.txtSecondary,
  display: 'block', marginBottom: 4, letterSpacing: '.03em',
}

export const input = {
  width: '100%', padding: '9px 12px',
  background: T.surface3, border: `1px solid ${T.border}`,
  borderRadius: T.radiusSm, fontSize: 12,
  fontFamily: T.font, color: T.txtPrimary,
  outline: 'none', marginBottom: 14,
}

export const btnPrimary = {
  padding: '9px 20px', background: T.blue, color: '#fff',
  border: 'none', borderRadius: T.radiusSm,
  fontSize: 12, fontWeight: 700, fontFamily: T.font,
  cursor: 'pointer', letterSpacing: '.02em',
}

export const btnSecondary = {
  padding: '9px 20px', background: T.surface3,
  color: T.txtPrimary, border: `1px solid ${T.border}`,
  borderRadius: T.radiusSm, fontSize: 12, fontWeight: 600,
  fontFamily: T.font, cursor: 'pointer',
}

export const btnDanger = {
  padding: '9px 20px', background: 'rgba(248,81,73,.15)',
  color: '#f85149', border: '1px solid rgba(248,81,73,.3)',
  borderRadius: T.radiusSm, fontSize: 12, fontWeight: 600,
  fontFamily: T.font, cursor: 'pointer',
}

export const kpiCard = {
  background: T.surface, borderRadius: T.radius,
  border: `1px solid ${T.border}`, padding: '16px 20px',
}

export const alert = {
  ok:  { background:'rgba(63,185,80,.12)',  border:'1px solid rgba(63,185,80,.25)',  color:'#3fb950', borderRadius:T.radiusSm, padding:'10px 14px', fontSize:12, fontWeight:500, marginBottom:14 },
  err: { background:'rgba(248,81,73,.12)',  border:'1px solid rgba(248,81,73,.25)',  color:'#f85149', borderRadius:T.radiusSm, padding:'10px 14px', fontSize:12, fontWeight:500, marginBottom:14 },
  info:{ background:'rgba(30,144,255,.10)', border:'1px solid rgba(30,144,255,.25)', color:'#58aeff', borderRadius:T.radiusSm, padding:'10px 14px', fontSize:12, fontWeight:500, marginBottom:14 },
}
